// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"1f705386","616":"c1d4e9bd","634":"aeed368c","696":"b7f2c1e4","937":"394b863c"}[chunkId] + ".chunk.css";
};